module.exports = __webpack_public_path__ + "img/istanbul-1261194_1280_V2.270929b0.png";